import { api } from '../lib/api';

export type SubscriptionStatus =
  | 'none'
  | 'incomplete'
  | 'trialing'
  | 'active'
  | 'past_due'
  | 'canceled'
  | 'unpaid'
  | 'paused';

export type Subscription = {
  _id: string;
  tenant: string;
  stripeCustomerId: string | null;
  stripeSubscriptionId: string | null;
  status: SubscriptionStatus;
  currentPeriodStart: string | null;
  currentPeriodEnd: string | null;
  cancelAtPeriodEnd: boolean;
  canceledAt: string | null;
  setupPaid: boolean;
  setupPaidAt: string | null;
  monthlyPriceId: string | null;
  lastInvoiceId: string | null;
  lastInvoiceAmount: number | null;
  lastInvoiceStatus: string | null;
  defaultPaymentMethodLast4: string | null;
  defaultPaymentMethodBrand: string | null;
};

export async function fetchSubscription(): Promise<Subscription> {
  const { data } = await api.get('/api/billing/subscription');
  return data.subscription;
}

export async function startCheckout(opts: { successUrl?: string; cancelUrl?: string } = {}) {
  const { data } = await api.post('/api/billing/checkout', opts);
  return data as { url: string; sessionId: string };
}

export async function openPortal(opts: { returnUrl?: string } = {}) {
  const { data } = await api.post('/api/billing/portal', opts);
  return data as { url: string };
}

export async function refreshSubscription() {
  const { data } = await api.post('/api/billing/refresh', {});
  return data.subscription as Subscription;
}
